import Vue from 'vue'
import { URL_LOTS } from '@/constants/urls.js'
import { LOT_CLARIFICATIONS_MANAGEMENT, ERRORS, AXIOS_REQUESTS } from '@/constants/store.js'

const state = {
  [LOT_CLARIFICATIONS_MANAGEMENT.STATE.CLARIFICATIONS]: null,
  [LOT_CLARIFICATIONS_MANAGEMENT.STATE.CURRENT_CLARIFICATION]: null
}

const actions = {
  async [LOT_CLARIFICATIONS_MANAGEMENT.ACTIONS.GET_CLARIFICATIONS_LIST] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_LOTS}/${model.lotId}/clarifications?${Vue.helpers.getQueryParamsString()}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(LOT_CLARIFICATIONS_MANAGEMENT.MUTATIONS.GET_CLARIFICATIONS_LIST, resp.data)
  },
  async [LOT_CLARIFICATIONS_MANAGEMENT.ACTIONS.GET_CLARIFICATION_INFO] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_LOTS}/${model.lotId}/clarifications/${model.clarificationId}?${Vue.helpers.getQueryParamsString()}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(LOT_CLARIFICATIONS_MANAGEMENT.MUTATIONS.GET_CLARIFICATION_INFO, resp.data)
  },
  async [LOT_CLARIFICATIONS_MANAGEMENT.ACTIONS.CREATE_CLARIFICATION] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_LOTS}/${model.lotId}/clarifications`,
      model: model.clarification
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.POST_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [LOT_CLARIFICATIONS_MANAGEMENT.ACTIONS.UPDATE_CLARIFICATION] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_LOTS}/${model.lotId}/clarifications/${model.clarificationId}`,
      model: model.clarification
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.PUT_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [LOT_CLARIFICATIONS_MANAGEMENT.ACTIONS.DELETE_CLARIFICATION] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_LOTS}/${model.lotId}/clarifications/${model.clarificationId}`
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.DELETE_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [LOT_CLARIFICATIONS_MANAGEMENT.ACTIONS.CLEAR_CLARIFICATION_INFO] ({ commit }) {
    commit(LOT_CLARIFICATIONS_MANAGEMENT.MUTATIONS.CLEAR_CLARIFICATION_INFO)
  },
  async [LOT_CLARIFICATIONS_MANAGEMENT.ACTIONS.CLEAR_CLARIFICATIONS_LIST] ({ commit }) {
    commit(LOT_CLARIFICATIONS_MANAGEMENT.MUTATIONS.CLEAR_CLARIFICATIONS_LIST)
  }
}

const mutations = {
  [LOT_CLARIFICATIONS_MANAGEMENT.MUTATIONS.GET_CLARIFICATION_INFO] (state, clarification) {
    state[LOT_CLARIFICATIONS_MANAGEMENT.STATE.CURRENT_CLARIFICATION] = clarification
  },
  [LOT_CLARIFICATIONS_MANAGEMENT.MUTATIONS.GET_CLARIFICATIONS_LIST] (state, clarifications) {
    state[LOT_CLARIFICATIONS_MANAGEMENT.STATE.CLARIFICATIONS] = clarifications
  },
  [LOT_CLARIFICATIONS_MANAGEMENT.MUTATIONS.CLEAR_CLARIFICATION_INFO] (state) {
    state[LOT_CLARIFICATIONS_MANAGEMENT.STATE.CURRENT_CLARIFICATION] = null
  },
  [LOT_CLARIFICATIONS_MANAGEMENT.MUTATIONS.CLEAR_CLARIFICATIONS_LIST] (state) {
    state[LOT_CLARIFICATIONS_MANAGEMENT.STATE.CLARIFICATIONS] = null
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
